export default "__VITE_ASSET__CViAquO2__"